// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__pZUwK","head":"ProcedureTableInfo_head__3xZgM"};